import type { SimulationConfig } from '../../config/schema';
import type { ControlSetupContext } from './helpers';

function updateChunkSizeOptions(resolution: number): void {
  const el = document.getElementById('chunkSize') as HTMLSelectElement | null;
  if (!el) return;
  for (const opt of Array.from(el.options)) {
    opt.disabled = parseInt(opt.value) >= resolution;
  }
}

export function setupRenderControls(ctx: ControlSetupContext): void {
  const { config: c, controls: ui } = ctx;

  ui.bindControl('vizMode', (v) => {
    c.vizMode = v as SimulationConfig['vizMode'];
    ui.updateModeUI(c);
    ctx.markStale();
  }, 'change');

  ui.bindControl('resolution', (v) => {
    c.resolution = parseInt(v) as SimulationConfig['resolution'];
    updateChunkSizeOptions(c.resolution);
    if (c.chunkSize >= c.resolution) {
      const sizes = [2048, 1024, 512, 256] as const;
      const fallback = sizes.find(s => s < c.resolution) ?? 256;
      c.chunkSize = fallback as SimulationConfig['chunkSize'];
      ui.setVal('chunkSize', String(fallback));
    }
    ctx.markStale();
  }, 'change');

  ui.bindControl('chunkSize', (v) => {
    c.chunkSize = parseInt(v) as SimulationConfig['chunkSize'];
    ctx.markStale();
  }, 'change');

  ui.bindControl('colormap', (v) => {
    c.colormap = parseInt(v) as SimulationConfig['colormap'];
    ui.updateLegend(c.colormap);
  }, 'change');

  ui.bindControl('toneMapping', (v) => {
    c.toneMapping = parseInt(v) as SimulationConfig['toneMapping'];
  }, 'change');
}
